export default "__VITE_ASSET__BhDyo3YV__"